import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { Pages } from "components/pages";

export default function CompanyRoute() {

    const { path } = useRouteMatch();
    
    return (
        <>
            <Switch>
                <Route path={`${path}`} exact>
                    <Pages.CompanyPage />
                </Route>
                <Route path={`${path}/create`} exact>
                    <Pages.CompanyCreatePage />
                </Route>
                <Route path={`${path}/page/:id`} exact>
                    <Pages.CompanyPage />
                </Route>
                <Route path={`${path}/:id`}>
                    { ( { match, history } ) => <Pages.CompanyEditPage match={ match } history={ history }/> }
                </Route>
            </Switch>
        </>
    );

}